// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1RFu3","list":"styles_list__2mX_F"};